import { Modifier, EditorState, RichUtils, SelectionState } from 'draft-js';

const insertText = ({
  editorState,
  selection,
  textToInsert,
  removeOldEntity = false,
}) => {
  const currentContent = editorState.getCurrentContent();

  const content = removeOldEntity
    ? Modifier.applyEntity(currentContent, selection, null)
    : currentContent;

  const newContent = Modifier.replaceText(content, selection, textToInsert);

  const newEditorState = EditorState.push(
    editorState,
    newContent,
    'insert-characters'
  );

  return newEditorState;
};

const insertTextWithPhone = ({
  editorState,
  selection,
  textToInsert,
  phone,
  removeOldEntity = false,
}) => {
  let newEditorState = insertText({
    editorState,
    selection,
    textToInsert,
    removeOldEntity,
  });

  const contentWithLinkEntity = newEditorState
    .getCurrentContent()
    .createEntity('LINK', 'MUTABLE', { url: `tel:${phone}`});

  const linkEntityKey = contentWithLinkEntity.getLastCreatedEntityKey();

  newEditorState = EditorState.set(newEditorState, {
    currentContent: contentWithLinkEntity,
  });

  const newSelection = newEditorState.getSelection().merge({
    anchorOffset: selection.getStartOffset(),
    focusOffset: selection.getStartOffset() + textToInsert.length,
  });

  newEditorState = RichUtils.toggleLink(
    newEditorState,
    newSelection,
    linkEntityKey
  );

  const endSelection = new SelectionState({
    anchorKey: newSelection.getAnchorKey(),
    anchorOffset: newSelection.getEndOffset(),
    focusKey: newSelection.getFocusKey(),
    focusOffset: newSelection.getEndOffset(),
    hasFocus: true,
  });

  const contentWithExtraSpace = Modifier.insertText(
    newEditorState.getCurrentContent(),
    endSelection,
    '\u200B'
  );

  newEditorState = EditorState.push(
    newEditorState,
    contentWithExtraSpace,
    'insert-characters'
  );

  newEditorState = EditorState.acceptSelection(newEditorState, endSelection);

  return newEditorState;
};

const findPhoneEntityRange = (block, contentState, selection) => {
  let linkRange = null;

  block.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity();
      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === 'LINK'
      );
    },
    (start, end) => {
      if (
        selection.getStartOffset() >= start &&
        selection.getStartOffset() <= end
      ) {
        linkRange = new SelectionState({
          anchorKey: block.getKey(),
          anchorOffset: start,
          focusKey: block.getKey(),
          focusOffset: end,
        });
      }
    }
  );

  return linkRange;
};

export const addPhone = ({ editorState, textToInsert, phone, dopPhone }) => {
  const allPhone = dopPhone ? `${phone}p${dopPhone}` : phone
  const selection = editorState.getSelection();
  return insertTextWithPhone({
    editorState,
    selection,
    textToInsert,
    phone: allPhone,
    removeOldEntity: false,
  });
};

export const editPhone = ({ editorState, textToInsert, phone, dopPhone }) => {
  const allPhone = dopPhone ? `${phone}p${dopPhone}` : phone
  const selection = editorState.getSelection();
  const currentContent = editorState.getCurrentContent();

  const blockWithLinkAtBeginning = currentContent.getBlockForKey(
    selection.getStartKey()
  );

  const linkRange = findPhoneEntityRange(
    blockWithLinkAtBeginning,
    currentContent,
    selection
  );

  if (linkRange) {
    return insertTextWithPhone({
      editorState,
      selection: linkRange,
      textToInsert,
      phone: allPhone,
      removeOldEntity: true,
    });
  }

  return editorState;
};

export const removePhoneFromText = ({ editorState }) => {
  const selection = editorState.getSelection();
  const currentContent = editorState.getCurrentContent();

  const blockWithLinkAtBeginning = currentContent.getBlockForKey(
    selection.getStartKey()
  );

  const linkRange = findPhoneEntityRange(
    blockWithLinkAtBeginning,
    currentContent,
    selection
  );

  if (linkRange) {
    const contentWithoutLinkEntity = Modifier.applyEntity(
      currentContent,
      linkRange,
      null
    );

    let newEditorState = EditorState.set(editorState, {
      currentContent: contentWithoutLinkEntity,
    });

    return newEditorState;
  }

  return editorState;
};
